export default __webpack_public_path__ + "static/media/COLIBRI_Poesía Canciones del Colibri .905b586c.jpeg";